import { InfoCardProps } from "./types";

// Info kartica u stilu kartice vozila (VehicleInfoCard).
const InfoCard: React.FC<InfoCardProps> = ({ label, value }) => (
  <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
    <div className="text-sm text-slate-600">{label}</div>
    <div className="text-md font-medium text-slate-800 truncate">
      {value || "-"}
    </div>
  </div>
);

export default InfoCard;
